import LabeledIncomeStatus from "components/molecules/labeledStatus/LabelIncomeStatus";
import { Form } from "components/organisms";
import {
  CASH_FLOW_TABS,
  cashFlowInitialValues,
} from "components/organisms/forms/cash-flow/CashFlowForm";
import { useCustomParamId } from "hooks/useParamId";
import middleware from "middleware";
import { useTranslation } from "react-i18next";

import { useLocation, useNavigate } from "react-router-dom";

import { useGetIncome } from "services/balance";
import { INCOME_TYPE } from "services/balance/types";

const Income = () => {
  const labelId = useCustomParamId("id", "/label");
  const incomeId = useCustomParamId("id", `/${labelId}/income`);

  const income = useGetIncome(incomeId);

  const goToListPath = `balance`;

  return (
    <Form.CashFlow
      initialValues={
        income.data
          ? middleware.income.queryToForm(income.data)
          : cashFlowInitialValues
      }
      onSubmit={() => {}}
      tittle={income.data?.incomeName}
      backPath={goToListPath}
      disableTabs={[CASH_FLOW_TABS.repayments]}
      status={{
        isLoading: income.isLoading,
        displayMode: true,
        refetch: income.refetch,
      }}
      topbarContent={
        <div className="flex items-center w-max">
          <div>
            {!!income.data && (
              <LabeledIncomeStatus
                status={
                  income.data?.incomeType === INCOME_TYPE.cost
                    ? INCOME_TYPE.basic
                    : income.data?.incomeType
                }
              />
            )}
          </div>
        </div>
      }
    />
  );
};

export default Income;
